import React, { useState, useEffect } from "react";
import {
  Container, Typography, Box, Grid, Button, Card, CardContent,
  Chip, Dialog, DialogTitle, DialogContent, DialogActions, TextField,
  CircularProgress, Divider, Stack,
} from "@mui/material";
import { MailOutline, Reply, History } from "@mui/icons-material";

function SuperAdminTickets() {
  const [queries, setQueries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [replyDialogOpen, setReplyDialogOpen] = useState(false);
  const [selectedQuery, setSelectedQuery] = useState(null);
  const [replyMessage, setReplyMessage] = useState("");
  const [submittingReply, setSubmittingReply] = useState(false);

  useEffect(() => { fetchAllQueries(); }, []);

  const fetchAllQueries = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await fetch("/api/support-queries", {
        headers: { 'Authorization': token ? `Bearer ${token}` : '' }
      });
      if (response.ok) {
        const data = await response.json();
        setQueries(data.map((q, i) => ({
          ...q,
          id: q._id || q.id || `query-${i}`,
          date: new Date(q.createdAt || q.created_at || Date.now()).toLocaleString()
        })));
      }
    } catch (error) { console.error(error); } finally { setLoading(false); }
  };

  const handleSendReply = async () => {
    if (!replyMessage.trim() || !selectedQuery) return;

    // FINAL FIX: Check every possible field name for the email
    const recipientEmail = selectedQuery.user_email || selectedQuery.email || selectedQuery.candidate_email;

    if (!recipientEmail) {
      alert("Error: No email address found for this ticket. Please check your database.");
      return;
    }

    setSubmittingReply(true);
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`/api/support-queries/${selectedQuery.id}/reply`, {
        method: "POST",
        headers: { "Content-Type": "application/json", 'Authorization': token ? `Bearer ${token}` : '' },
        body: JSON.stringify({ replyMessage, email: recipientEmail }),
      });

      if (response.ok) {
        alert("Reply sent successfully!");
        setReplyDialogOpen(false);
        fetchAllQueries();
      } else {
        const err = await response.json();
        alert(err.message || "Failed to send");
      }
    } catch (error) { alert("Error occurred"); } finally { setSubmittingReply(false); }
  };

  if (loading) return <Box sx={{ display: "flex", justifyContent: "center", mt: 8 }}><CircularProgress /></Box>;

  return (
      <Container sx={{ py: 6 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 4 }}>
          <Typography variant="h4"
                      sx={{
                        color: "#4F46E5",
                        fontWeight: "bold",
                        mb: 2
                      }}
          >Support Tickets</Typography>
          <Button variant="outlined" startIcon={<History />} onClick={fetchAllQueries}>Refresh</Button>
        </Box>
        <Grid container spacing={3}>
          {queries.map((query) => (
              <Grid item xs={12} key={query.id}>
                <Card sx={{ borderLeft: 6, borderColor: query.status === 'resolved' ? 'success.main' : 'warning.main' }}>
                  <CardContent>
                    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                      <Typography variant="h6" color="primary">{query.subject || "No Subject"}</Typography>
                      <Chip label={(query.status || "pending").toUpperCase()} color={query.status === "resolved" ? "success" : "warning"} size="small" />
                    </Box>
                    <Typography variant="body2"><strong>From:</strong> {query.user_email || query.email || "Guest"}</Typography>
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="body1" sx={{ mb: 3 }}>{query.message}</Typography>
                    <Button
                        variant="contained"
                        onClick={() => { setSelectedQuery(query); setReplyDialogOpen(true); }}
                        disabled={query.status === "resolved"}
                        sx={{ bgcolor: "#4338CA" }}
                    >
                      Send Reply
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
          ))}
        </Grid>
        <Dialog open={replyDialogOpen} onClose={() => setReplyDialogOpen(false)} fullWidth>
          <DialogTitle sx={{ bgcolor: '#4338CA', color: 'white' }}>Reply to Ticket</DialogTitle>
          <DialogContent dividers>
            <TextField fullWidth multiline rows={4} value={replyMessage} onChange={(e) => setReplyMessage(e.target.value)} variant="outlined" margin="normal" />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setReplyDialogOpen(false)}>Cancel</Button>
            <Button variant="contained" onClick={handleSendReply} disabled={!replyMessage.trim() || submittingReply} sx={{ bgcolor: "#4338CA" }}>
              {submittingReply ? "Sending..." : "Send Email Reply"}
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
  );
}
export default SuperAdminTickets;
